document.addEventListener('DOMContentLoaded', function() {
  // Toàn bộ logic validate và submit form đã được chuyển vào snippet
  // (ví dụ: quote-form-hangtags.liquid) để tích hợp API gửi mail.
  // JS này được comment lại để tránh conflict alert().
});
